import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { sectionVariants } from "../../config/animations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faHome, faSignal, faClock } from "@fortawesome/free-solid-svg-icons";

function Footer() {
  const [ip, setIp] = useState(null);
  const [ping, setPing] = useState(null);
  const [time, setTime] = useState(new Date().toLocaleTimeString());

  useEffect(() => {
    const fetchIP = async () => {
      const startTime = Date.now();
      try {
        const ipRes = await fetch("https://www.cloudflare.com/cdn-cgi/trace", { signal: AbortSignal.timeout(3000) });
        const endTime = Date.now();
        setPing(endTime - startTime);

        if (!ipRes.ok) throw new Error("Blocked");
        const dataText = await ipRes.text();
        const ipMatch = dataText.match(/ip=(.+)/);
        setIp(ipMatch ? ipMatch[1] : "Private");
      } catch (err) {
        setIp("Protected");
        setPing(null);
      }
    };

    fetchIP();
    const ipInterval = setInterval(fetchIP, 10000);
    const clockInterval = setInterval(() => setTime(new Date().toLocaleTimeString()), 1000);

    return () => {
      clearInterval(ipInterval);
      clearInterval(clockInterval);
    };
  }, []);

  const chipStyle = "px-2.5 py-1 rounded-lg border border-white/30 dark:border-slate-800/50 bg-white/60 dark:bg-slate-900/40 text-[10px] sm:text-[11px] font-semibold uppercase tracking-wider text-slate-800 dark:text-slate-400 flex items-center gap-1.5 transition-all hover:scale-105 active:scale-95 shadow-sm";

  return (
    <motion.footer
      className="flex flex-col md:flex-row p-2.5 sm:p-3 rounded-xl shadow-xl bg-white/40 dark:bg-slate-900/60 backdrop-blur-xl border border-white/20 dark:border-slate-800/50 transition-all duration-500 gap-2.5 md:gap-3 items-center justify-between"
      variants={sectionVariants}
    >
      {/* Left Group */}
      <div className="flex flex-wrap justify-center gap-2">
        <div className={chipStyle}>
          <span>{new Date().getFullYear()} © SoulLab_</span>
        </div>
        <div className={chipStyle}>
          <FontAwesomeIcon icon={faClock} className="text-slate-400" />
          <span className="font-mono">{time}</span>
        </div>
      </div>

      {/* Middle Group */}
      <div className="flex flex-wrap justify-center gap-2">
        <div className={chipStyle}>
          <div className="relative flex h-1.5 w-1.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500"></span>
          </div>
          <span className="text-[9px]">Sytem Stable</span>
        </div>

        <div className={chipStyle}>
          <FontAwesomeIcon icon={faGlobe} className="text-slate-400" />
          <span className="font-mono line-clamp-1 max-w-[120px] md:max-w-none">{ip || "Loading..."}</span>
        </div>
        {ping !== null && (
          <div className={chipStyle}>
            <FontAwesomeIcon icon={faSignal} className={ping < 100 ? "text-emerald-500" : ping < 300 ? "text-yellow-500" : "text-red-500"} />
            <span className="font-mono">{ping}ms</span>
          </div>
        )}
      </div>

      {/* Right Group */}
      <a href="/" className={`${chipStyle} hover:bg-white dark:hover:bg-slate-800 cursor-pointer`}>
        <FontAwesomeIcon icon={faHome} />
        <span>Trang chủ</span>
      </a>
    </motion.footer>
  );
}

export default Footer;

